export default __webpack_public_path__ + "static/grid-types-light-f160d7047355bcbbe4037be1da102238.png";